module.exports = __webpack_public_path__ + "static/media/faq_video.0dc47917.mp4";